import {
  FormulaQueryProperty,
  QuantifyQuery,
} from '@modules/quantify/store/types';
import { getHasMetadataFilterForEqlField } from '@modules/quantify/utils';
import { mapToEQL } from 'v2/core/repository/eql/mappers';
import { EQLFunctionName, ExpressionType } from 'v2/core/repository/eql/types';
import { combineWhereClauses } from 'v2/core/services/queryBuilder/combineWhereClauses';
import {
  EmptyWhereClause,
  OperationType,
  WhereClause,
} from 'v2/core/services/queryBuilder/whereClause';

interface ShouldUpdateCompareDenominatorOnFilterChangeParams {
  groupBy: QuantifyQuery['groupByField'];
  compareWhereClause: WhereClause | null;
  compareDenominatorWhereClause: FormulaQueryProperty['denominatorWhereClause'];
  formulaID: FormulaQueryProperty['eqlFunction'];
}

export const shouldUpdateCompareDenominatorOnFilterChange = ({
  groupBy,
  compareWhereClause,
  compareDenominatorWhereClause,
  formulaID,
}: ShouldUpdateCompareDenominatorOnFilterChangeParams) => {
  if (formulaID !== EQLFunctionName.NormaliseByPercent) {
    return false;
  }

  const metadataFilter = getHasMetadataFilterForEqlField(groupBy);

  if (!compareWhereClause) {
    return false; // compareQuery is not the whereClause type
  }

  const compareDenominatorWhereClauseEql = mapToEQL({
    expressionType: ExpressionType.Aggregates,
    sourceDetailsMap: new Map(),
    whereClause: compareDenominatorWhereClause ?? EmptyWhereClause,
  });

  if (!metadataFilter) {
    const compareWhereClauseEql = mapToEQL({
      expressionType: ExpressionType.Aggregates,
      sourceDetailsMap: new Map(),
      whereClause: compareWhereClause,
    });
    return compareWhereClauseEql === compareDenominatorWhereClauseEql;
  }

  const combinedCompareWhereClauseEql = mapToEQL({
    expressionType: ExpressionType.Aggregates,
    sourceDetailsMap: new Map(),
    whereClause: combineWhereClauses(
      compareWhereClause,
      metadataFilter,
      OperationType.AND,
    ),
  });

  return combinedCompareWhereClauseEql === compareDenominatorWhereClauseEql;
};
